import script from "./PoapPage.vue?vue&type=script&lang=ts&setup=true"
export * from "./PoapPage.vue?vue&type=script&lang=ts&setup=true"

import "./PoapPage.vue?vue&type=style&index=0&id=3e45e051&lang=css"

const __exports__ = script;

export default __exports__